import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import { Twemoji } from "react-emoji-render";
import styled from "styled-components";
import { margin } from "styled-system";
var StyledEmoji = styled(Twemoji).withConfig({
  displayName: "Emoji__StyledEmoji",
  componentId: "ihpuqw-0"
})(["& > img{width:", "em !important;height:", "em !important;margin:0 !important;}display:inline-block;", ""], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, margin);

var Emoji = function Emoji(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1.5 : _ref$size,
      text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "text"]);

  return /*#__PURE__*/React.createElement(StyledEmoji, Object.assign({
    size: size,
    text: text,
    svg: true
  }, props));
};

Emoji.defaultProps = {
  mt: 0,
  mr: 0,
  mb: 0,
  ml: 0
};
export default Emoji;